// src/util/tracker.js

// 初始化跟踪器实例
const initTracker = () => {
  try {
    if (typeof RaEventTracker === "undefined") {
      throw new Error("[RaEventTracker] 依赖脚本未正确加载");
    }

    const tracker = new RaEventTracker(
      { url: "https://collect.rastargames.com/v1/webevent/collect/" },
      { siteId: "gQOdZ5yZmjReOBVH" },
      "5B~.RAbg3rlKQx8("
    );

    console.log("RaEventTracker 初始化成功");
    return tracker;
  } catch (error) {
    console.error("初始化 RaEventTracker 失败:", error);
    // 根据需要处理错误，例如重试或通知用户
  }
};

// 定义 Vue 插件
export default {
  install(app) {
    const tracker = initTracker();

    // 方案 1：挂载到全局属性（兼容 Options API）
    app.config.globalProperties.$tracker = tracker;

    // 方案 2：通过 provide 注入（推荐 Composition API）
    app.provide("tracker", tracker);
  },
};
